import { routes } from './routes'
import { vsName as userProfileModuleName } from '../application/userProfileModule'
import { vsModuleName as chartModuleName } from "../ui/chart"
import { vsComponentName as dailyReadingsGraphComponentName, dailyReadingsGraphComponentOptions} from "./views/dailyReadings/graph"

var mod = angular.module('SlotTrak.Machines.Progressives', ['records', userProfileModuleName, chartModuleName])

mod
  .config(routes)
  .component(dailyReadingsGraphComponentName, dailyReadingsGraphComponentOptions)

export default mod.name